<ion-header>
  <ion-toolbar>
    <ion-title>{{category?.name}}</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice/home" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-row>
    <ion-col size="6" *ngFor="let cat of category.children; let i = index;">
      <ion-button
        expand="block"
        class="square_button"
        color="light"
        (click)="cat.is_parent ? goCategory(cat) : goBusinesses(cat)"
      >
        <div class="vertical">
          <img slot="start" [src]="cat.icon" />
          <span>{{cat.name}}</span>
        </div>
      </ion-button>
    </ion-col>
  </ion-row>
</ion-content>
